module.exports = __webpack_public_path__ + "static/media/schody12 - schody drewniane zabiegowe nakladane.29bb5ae3.jpg";